import { useEffect, useState } from "react";
import { api } from "@/lib/api";

function PageHeader({ overline, title }) {
  return (
    <div className="border-b border-navy/10 px-8 py-8 bg-cream">
      <div className="overline text-gold-deep">{overline}</div>
      <h1 className="font-serif text-3xl md:text-4xl text-navy mt-2">{title}</h1>
      <div className="gold-rule mt-4" />
    </div>
  );
}

export default function Messages() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/messages");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/messages/${id}/read`);
    load();
  };

  return (
    <div data-testid="messages-page">
      <PageHeader overline="Inbox" title="Public contact messages" />
      <div className="p-8">
        <div className="bg-white border border-navy/10">
          {items.length === 0 && (
            <div className="p-12 text-center text-navy/40 italic">No messages yet.</div>
          )}
          {items.map((m) => (
            <div
              key={m.id}
              className={`border-b border-navy/5 last:border-b-0 p-5 ${m.read ? "opacity-60" : ""}`}
              data-testid={`message-${m.id}`}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    {!m.read && <span className="w-2 h-2 bg-gold rounded-full inline-block" />}
                    <div className="font-medium text-navy">{m.name}</div>
                    <span className="text-xs text-navy/50">· {m.email}</span>
                    {m.organization && <span className="text-xs text-navy/50">· {m.organization}</span>}
                  </div>
                  <div className="mt-2 text-navy/85 whitespace-pre-wrap">{m.message}</div>
                  <div className="text-xs text-navy/40 mt-2">{(m.created_at || "").slice(0, 16).replace("T", " ")}</div>
                </div>
                {!m.read && (
                  <button onClick={() => markRead(m.id)} data-testid={`message-mark-read-${m.id}`} className="text-xs uppercase tracking-widest text-gold-deep hover:text-navy">
                    Mark read
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
